import React from 'react';

/*
 * Field — canonical labelled form control wrapper (the .form-group treatment:
 * sentence-case label, token input border + accent focus ring, hint and error
 * states). Pass the actual <input>/<select>/<textarea> as children so existing
 * control markup drops straight in.
 *
 *   <Field label="Guest name" htmlFor="name" required>
 *     <input id="name" ... />
 *   </Field>
 */
export default function Field({
  label,
  htmlFor,
  required = false,
  hint,
  error,
  fullWidth = false,
  className = '',
  children,
}) {
  const cls = [
    'form-group',
    fullWidth ? 'full-width' : '',
    error ? 'has-error' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={cls}>
      {label && (
        <label htmlFor={htmlFor}>
          {label}
          {required && <span className="required"> *</span>}
        </label>
      )}
      {children}
      {hint && !error && <span className="calc-note">{hint}</span>}
      {error && <span className="field-error">{error}</span>}
    </div>
  );
}
